// DS: B5
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import classnames from 'classnames';
import Button from '../Button';
import s from './ButtonB5.scss';
class ButtonB5 extends React.Component {
    render() {
        const _this_props = this.props, { className, children, withBackground = true } = _this_props, rest = _object_without_properties(_this_props, [
            "className",
            "children",
            "withBackground"
        ]);
        return /*#__PURE__*/ React.createElement(Button, _object_spread_props(_object_spread({}, rest), {
            className: classnames(s['button'], withBackground && s['with-background'], className),
            fullWidth: false
        }), this.renderIcon(), children);
    }
    renderIcon() {
        const Component = this.props.icon;
        const _this_props_iconProps = this.props.iconProps, { className } = _this_props_iconProps, rest = _object_without_properties(_this_props_iconProps, [
            "className"
        ]);
        return /*#__PURE__*/ React.createElement(Component, _object_spread({
            className: classnames(s['icon'], className)
        }, rest));
    }
}
export default ButtonB5;
